<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300px"
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ $t('device.confirmcode') }}
      </v-card-title>
      <v-card-text>
        <div style="color: red; font-size: 1.5rem;" class="font-weight-bold text-center mt-2">{{ $t('device.confirmmessage') }}</div>
        <v-row class="mt-2 mb-2">
          <div class="ma-auto position-relative" style="max-width: 350px;">
            <v-row>
              <v-col cols="3" class="d-flex justify-end align-center font-weight-bold" style="font-size: 1.5rem;">TNG -</v-col>
              <v-col cols="9">
                <v-otp-input
                  ref="otpcmp"
                  v-model="otp"
                  :disabled="loading"
                  length="3"
                  type="number"
                  @finish="onFinish"
                  hide-details
                ></v-otp-input>
                <v-overlay absolute :value="loading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-overlay>
              </v-col>
            </v-row>
          </div>
        </v-row>
        <v-row class="mt-4">
          <div id="devicemap" style="width:600px;height:384.2px;"></div>
          <img v-if="snapshot != null" :src="snapshot" :aspect-ratio="16/9" width="600" class="ma-0 ml-2"/>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          text
          @click="cancel()"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="confirm()"
        >
          {{ $t('common.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      color="error"
      :timeout="4000"
      top
    >
      {{ text }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import * as atlas from 'azure-maps-control';

var map;

export default {
  props: ["dialog", "snapshot", "gps"],
  data() {
    return {
      snackbar: false,
      snackbarColor: 'default',
      otp: '',
      text: '',
      loading: false,
      opentime: null,
    }
  },
  mounted() {
    //this.$refs.otpcmp.focus()
    console.log("Mounting DialogConfirmWrRequest")
    this.opentime = new Date()
    this.$nextTick(() => {
      console.log("mounted::nextTick")
      this.getMap()
      this.$refs.otpcmp.focus()
    })
  },
  computed: {
    ...mapGetters(["getAzureMapKey"]),
  },
  methods: {
    ...mapMutations(["mShowErrorMessage"]),
    cancel() {
      this.$emit("cancel")
    },
    confirm() {
      let closetime = new Date()
      if ((closetime - this.opentime)/1000 > 10) {
        this.mShowErrorMessage(this.$i18n.t("device.error.requestTooOld"))
        this.$emit("cancel")
      }
      else {
        this.$emit("confirm")
      }
    },
    onFinish (rsp) {
      this.loading = true
      this.$log.debug(`Processed OTP with "${rsp}"`)
      this.$log.debug(this.$route.params.id)
      this.$log.debug("TNG-" + rsp)
      if (this.$route.params.id == "TNG-" + rsp) {
        this.loading = false
        this.confirm()
      }
      else {
        setTimeout(() => {
          this.loading = false
          this.text = `Input TNG-${rsp} is not correct`
          this.snackbar = true
        }, 500)
      }

    },
    getMap() {
      map = new atlas.Map('devicemap', {
          center: [this.gps.lon, this.gps.lat],
          zoom: 12,
          view: 'Auto',
          authOptions: {
              //use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE: The primary key should be used as the key.
              authType: 'subscriptionKey',
              subscriptionKey: this.getAzureMapKey
          }
      });
      let _this = this;
      map.events.add('ready', function () {
        let {lat, lon} = _this.gps;
          map.markers.add(new atlas.HtmlMarker({
              htmlContent: _this.svgMarker(),
              color: 'DodgerBlue',
              position: [lon, lat]
          }));
      });
    },
    svgMarker() {
      return `<svg width="77" height="50" viewBox="0 0 77.00005 50.000032"
        version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
        <g>
          <path
            style="fill:#ff0000;fill-opacity:1;stroke:#556689;stroke-width:0.443176px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 44.492274,25.071888 -5.341814,13.080606 5.547269,-1.095755 -6.300602,13.01213 15.683026,-18.353937 -8.012726,1.643632 5.889697,-8.081207 z"
            id="path6442" />
        </g>
      </svg>`
    }
  }
}
</script>

<style>

</style>